import styled, { css } from 'styled-components';
import { WinProbabilityWrapper } from '../../Play/play/playResults/WinProbability.style';
import { AnchorElement } from '@mlb/react-patterns/v4/components/Link/link.style';
import { ImageWrapper } from '@mlb/react-patterns/v4/components/Image/image.style';
import { TeamScoresWrapper } from '../../Play/play/PlayScores.style';
import { StyledBaseSVG } from '@mlb/react-patterns/v4/components/Basepaths/basepaths.style';

export const EventWrapper = styled.div`
  font-weight: bold;
  margin-top: var(--gameday-section-padding-sm);
  font-weight: 800;
  font-size: 24px;
  line-height: 24px;
  color: var(--gameday-primary-font-color);
`;

export const DescriptionWrapper = styled.div`
  margin-top: var(--gameday-section-padding-sm);
  font-weight: 500;
  font-size: 18px;
  line-height: 120%;
  color: var(--gameday-primary-font-color);
`;

export const ProbabilityWrapper = styled.div`
  ${({ isMobile }) => isMobile ? 'margin: 16px 0' : ''};
  ${WinProbabilityWrapper} {
      font-size: 18px;
      margin-top:0;
      color: var(--gameday-primary-font-color);
    }
`;

export const SituationWrapper = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  color: var(--gameday-primary-font-color);
  padding-top: ${({ $isMobile }) => $isMobile ? '70px' : '0'}; // 54px + 16px margin
  span {
    margin-left: 5px;
    margin-right: 5px;
    color: var(--gameday-divider-color);
  }
  ${TeamScoresWrapper} {
    font-size: 14px;
    line-height: 14px;
    color: var(--gameday-primary-font-color);
  }
  ${StyledBaseSVG} {
    display: inline-block;
    vertical-align: text-top;
    margin: 0 8px;
  }

`;

export const InningWrapper = styled.div`
  display: inline-block;
  text-transform: uppercase;
`;

export const CountWrapper = styled.div`
  display: inline-block;
  font-weight: 700;
  color: var(--gameday-primary-font-color);
`;

export const ScoreWrapper = styled.div`
  ${({ isMobile }) => isMobile ? css`margin-top: 16px;` : ''}
  display: inline-block;
`;

export const PlayerDataWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  margin: ${({ $batter }) => $batter ? '12px 16px 0px 0px' : '12px 0px 0px 16px'};
  text-align: ${({ $batter }) => $batter ? 'right' : 'left'};
`;

export const PlayerNameWrapper = styled.div`
  display: inline-block;
  font-size: ${({ $isMobile }) => $isMobile ? '14px' : '16px'};
  line-height: 18px;
  font-weight: 700;
  color: var(--gameday-primary-font-color);
  max-width: 135px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PlayerDetailsWrapper = styled.div`
  display: inline-block;
  line-height: 14px;
  font-weight: 700;
  color: var(--gameday-secondary-font-color);
`;

export const PlayerSpotInfo = styled.div`
  height: 14px;
  line-height: 14px;
  font-size: ${({ $isMobile }) => $isMobile ? '12px' : '14px'};
`;

export const PlayerSpotNameInfo = styled.div`
  height: 18px;
  line-height: 18px;
  margin-bottom: ${({ $isMobile }) => $isMobile ? '4px' : '8px'};
  display: flex;
  align-items: baseline;
  justify-content: ${({ $isMobile, $batter }) => $isMobile ? 'center' : $batter ? 'flex-end' : 'flex-start'};
`;

export const MatchupPlayerWrapper = styled.div`
  > a, ${ImageWrapper} {
    &:first-child {
      width: 64px;
      height: 64px;
      display: inline-block;
    }
  }

  ${AnchorElement} {
    color: var(--gameday-primary-font-color);
    &:hover {
      color: var(--gameday-link-color);
    }
  }

  ${({ $batter }) => $batter ? css`
    display: flex;
    justify-content: flex-start;
    flex-flow: row-reverse;
  ` : ''}
`;

export const MatchupWrapper = styled.div`
  display: flex;
  position: relative;
  margin: 16px 0px;

  ${MatchupPlayerWrapper} {
    flex-basis: 50%;
    flex-grow: 0;
    height: 65px;
  }
  ${({ isMobile }) => isMobile ? css`
    ${MatchupPlayerWrapper} {
      height: auto;
      display: flex;
      flex-flow: column;
      align-items: center;
      a, a > div:first-child {
        display: flex;
        margin: auto;
      }
      ${PlayerDataWrapper} {
        width: 100%;
        margin: 6px 0 0 0;
        text-align: center;

        ${PlayerNameWrapper} {
          a {
            display: inline;
          }
        }
      }
    }
  ` : ''}
`;

export const VsWrapper = styled.div`
    position: absolute;
    top: calc(50% - 32px);
    left: calc(50% - 20px);
    width: 40px;
    text-align: center;
    font-size: 18px;
    height: 18px;
    font-weight: bold;
    color: var(--gameday-secondary-font-color);
`;

export const InningStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: baseline;
`;

export const PlayerDataDivider = styled(PlayerDetailsWrapper)`
  margin: 0px 4px;
  color: var(--gameday-divider-color);

`;

export const StatcastWrapper = styled.div`
  margin: 16px 0px;
  display: flex;
`;

export const StatcastStat = styled.div`
  flex: 1 1 0px;
`;

export const StatcastLabel = styled(PlayerDetailsWrapper)`
  display: block;
`;

export const StatcastValue = styled.div`
  margin-top: 5px;
  font-size: ${({ isMobile }) => isMobile ? '20px' : '24px'};
  font-weight: bold;
  color: var(--gameday-primary-font-color);
`;

export const StatcastUnit = styled.div`
  font-size: 18px;
  display: inline;
  margin-left: 5px;
`;
